import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React, { useContext } from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import { styled, useThemeProps } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import ModalContext from '../ModalContext.js';
import { createComponentSlot } from '../../../modules/styling/theme.js';

var _templateObject;

var _excluded = ["onSubmit", "className", "sx", "variant", "children"];
var componentRoot = createComponentSlot({
  name: "CinModalSubmitButton",
  slot: "Root"
});

var SubmitButtonBase = function SubmitButtonBase(_ref) {
  var onSubmitCallback = _ref.onSubmit,
      className = _ref.className;
      _ref.sx;
      var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "contained" : _ref$variant,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(ModalContext),
      onSubmit = _useContext.onSubmit,
      submitLabel = _useContext.submitLabel,
      submitIcon = _useContext.submitIcon,
      submitDisabled = _useContext.submitDisabled,
      submitting = _useContext.submitting,
      slowSubmitting = _useContext.slowSubmitting,
      loading = _useContext.loading;

  if (!onSubmit) return null;
  var buttonVariant = variant === "text" || variant === "outlined" ? variant : "contained";
  return /*#__PURE__*/React.createElement(LoadingButton, _extends({
    startIcon: submitIcon,
    color: "success",
    onClick: function onClick() {
      onSubmitCallback && onSubmitCallback();
      onSubmit();
    },
    loading: submitting && (slowSubmitting || slowSubmitting === undefined),
    disabled: loading || submitting || submitDisabled
  }, props, {
    className: classnames(componentRoot.className, className),
    variant: buttonVariant
  }), children !== undefined ? children : submitLabel);
};

SubmitButtonBase.propTypes = {
  onSubmit: propTypes.func,
  className: propTypes.string,
  sx: propTypes.any,
  variant: propTypes.any
};
var SubmitButtonRoot = styled(SubmitButtonBase, componentRoot.styledOptions)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
/**
 * A button for submitting a modal
 */

var SubmitButton = function SubmitButton(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(SubmitButtonRoot, rootProps);
};

var SubmitButton$1 = SubmitButton;

export { SubmitButton$1 as default };
